import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import BASE_URL from "../../NetworkConfig/ApiConfig";
import { Typography } from "@mui/material";

export default function RedirectPage() {
    const { shortCode } = useParams();

    useEffect(() => {
        const redirect = async () => {
            try {
                // Load FingerprintJS
                const fp = await FingerprintJS.load();
                const result = await fp.get();
                const deviceId = result.visitorId;
                // Call backend redirect API
                console.log(`${BASE_URL}/redir/api/redirect/${shortCode}?deviceId=${deviceId}`)
                const resp = await fetch(
                    `${BASE_URL}/redir/api/redirect/${shortCode}?deviceId=${deviceId}`
                );

                const data = await resp.json();

                if (!data.success) {
                    alert("Link not found or expired");
                    window.location.href = "https://vybecerkle.com";
                    return;
                }

                if (data.success) {
                    window.location.href = data.longUrl;
                }
                // Redirect to the actual URL

            } catch (err) {
                console.error(err);
                alert("Something went wrong");
                window.location.href = "https://vybecerkle.com";
            }
        };

        redirect();
    }, [shortCode]);

    return <Typography style={{
        fontFamily: 'Poppins', fontWeight: 500, textAlign: 'center', marginTop: "20px"
    }}>We are redirecting you, please wait...</Typography>;
}
